export default "__VITE_ASSET__9bad37e8__"